import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ username, onLogin }) => {
  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <div className="welcome-header">
          <h1>Welcome, {username}!</h1>
          <p>Your account has been created successfully!</p>
          <p>Please log in to start building your decks.</p>
        </div>
        
        <div className="welcome-content">
          <div className="welcome-icon">🎉</div>
          <p className="welcome-message">
            You're all set to start building amazing Lorcana decks!
          </p>
          <div className="welcome-features">
            <div className="feature">
              <span className="feature-icon">🃏</span>
              <span>Build custom decks</span>
            </div>
            <div className="feature">
              <span className="feature-icon">💾</span>
              <span>Save your creations</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🔗</span>
              <span>Share with others</span>
            </div>
          </div>
        </div>

        <div className="welcome-actions">
          <button 
            className="login-button"
            onClick={onLogin}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen; 